import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-header',
  template: `
    <pt-breadcrumb *ngIf="showBreadcrumb"></pt-breadcrumb>
    <ng-content select='[beforeHeader]'></ng-content>

    <div class='pt-header'>
      <button
        *ngIf='enabledToBack'
        class='btn btn-link btn-radius-0 btn-sm mb-2'
        (click)='toBack.emit()'>
        <pt-icon [key]='IconArrowLeft'></pt-icon>
        {{'BUTTON.BACK' | translate}}
      </button>
      <div *ngIf='title' [innerHTML]="title"></div>
      <p><span *ngIf='description' [innerHTML]="description"></span>
        <ng-content></ng-content>
      </p>
    </div>
  `,
  styles: [`
    .pt-header {
      /*margin-bottom: 20px;*/
      margin: 10px 15px 20px 15px;
    }

    .pt-header div {
      font-size: 28px;
      font-weight: 300;
      padding-left: 8px;
    }

    .pt-header p {
      padding-left: 8px;
      display: flex;
      align-items: center;
    }

    .btn-radius-0 {
      border-radius: 0
    }
  `]
})
export class HeaderComponent {

  @Input() title: string;

  @Input() description: string;

  @Input() enabledToBack: boolean;

  @Input() showBreadcrumb = true;
  @Output() toBack = new EventEmitter();

  IconArrowLeft = IoniconsOutline.arrowLeft;
}
